export const GET_ALL_USERS = 'GET_ALL_USERS'
export const GET_SPECIFIC_USER = 'GET_SPECIFIC_USER'
export const GET_ALL_ROLES = 'GET_ALL_ROLES'
export const GET_ALL_QUEUES = 'GET_ALL_QUEUES'
export const GET_ALL_AGENTS = 'GET_ALL_AGENTS'
export const GET_ALL_RAMAIS = 'GET_ALL_RAMAIS'
export const GET_ALL_TAGS = 'GET_ALL_TAGS'
export const GET_ALL_CONFERENCIAS = 'GET_ALL_CONFERENCIAS'
export const GET_ALL_PESQUISAS = 'GET_ALL_PESQUISAS'
